import SitesController from './sites.controller';

export default {
    template: require('./sites.tpl.html'),
    controller: SitesController
};
